import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import {computed, watch, ref} from 'vue';

import {Scene} from 'Interfaces/interfaces';
const componentName = 'SceneTab';

export default /*#__PURE__*/_defineComponent({
  __name: 'SceneTab',
  props: {
	tabName: {
		type: String,
		default: ''
	},
	scene: {
		type: Object as () => Scene,
		default: () => ({})
	},
	index: {
		type: Number,
		default: 0
	},
	sceneAssociatedColor: {
		type: String,
		default: ''
	},
	activeIndex: {
		type: Number,
		default: 0
	}
},
  emits: ['updateVisibleSceneIndex', 'updateChosenScene', 'scrollUpdate'],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const hovering = ref<boolean>(false);
const props = __props;

const isDarkColor = (hexColor) => {
	// Remove the '#' if it's present
	hexColor = hexColor.replace('#', '');

	// Convert hex to RGB
	const r = parseInt(hexColor.substr(0, 2), 16);
	const g = parseInt(hexColor.substr(2, 2), 16);
	const b = parseInt(hexColor.substr(4, 2), 16);
	const brightness = (r * 0.299 + g * 0.587 + b * 0.114) / 255;

	// If brightness is less than or equal to 0.5, color is considered dark
	return brightness <= 0.5;
}

const isDark = computed(() => {
	return isDarkColor(props.sceneAssociatedColor);
})

const updateVisibleSceneIndex = () => {
	emit('scrollUpdate');
	emit('updateChosenScene', props.scene);
	emit('updateVisibleSceneIndex', props.index);
}

const style = computed(() => {
	let backgroundColor = hovering.value || buttonIsActive.value ? props.sceneAssociatedColor : 'white';
	let color = hovering.value && isDark.value ? 'white' : 'black';

	// If buttonIsActive is true, check isDark value for color
	if (buttonIsActive.value) {
		color = isDark.value ? 'white' : 'black';
	}

	return `background-color: ${backgroundColor}; color: ${color};`;
});

const mouseenter = () => {
	hovering.value = true;
};

const buttonIsActive = computed(() => {
	return props.index === props.activeIndex;
});

const mouseleave = () => {
	hovering.value = false;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "hotspot-scene__tab",
    type: "button",
    onClick: _withModifiers(updateVisibleSceneIndex, ["prevent"]),
    style: _normalizeStyle(style.value),
    onMouseenter: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (mouseenter()), ["prevent"])),
    onMouseleave: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (mouseleave()), ["prevent"])),
    innerHTML: __props.tabName
  }, null, 44 /* STYLE, PROPS, NEED_HYDRATION */, _hoisted_1))
}
}

})